import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { commonString } from "../../../../../AdminApi/commFunc";
import { useApi } from "../../../../../hooks/useApi";
import Flex from "../../../../DefaultStyles/Flex";
import Loader from "../../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../../Filters/DropDown";
import { Textarea } from "../../../../Input/Textarea";
import AlertModal from "../../../../Modal/AlertModal";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../Users/UserDetail/CommentModal/TargetContainer";
import FaqCategoryDropdown from "./FaqCategoryDropdown";

interface FaqCategoryDeleteModalProps extends DefaultModalCommonProps {}

export default function FaqCategoryDeleteModal({
  closeEvent,
}: FaqCategoryDeleteModalProps) {
  const { pathname } = useLocation();

  const [category, setCategory] = useState<OptionType>({
    value: "",
    label: "삭제할 카테고리 선택",
  });
  const [reason, setReason] = useState("");
  const [askDeleteModal, setAskDeleteModal] = useState(false);
  const [usingCategory, setUsingCategory] = useState(false);
  const [deleteAction, setDeleteAction] = useState(false);

  const [selectedCategoryId, setSelectedCategoryId] = useState(0); // 삭제할 카테고리

  const { response, loading, error } = useApi({
    method: "delete",
    url:
      deleteAction && selectedCategoryId > 0
        ? `category/${selectedCategoryId}`
        : undefined,
    data: {
      reason,
      type: commonString(pathname).type ?? 0,
    },
  });

  useEffect(() => {
    if (category?.value !== "") {
      setSelectedCategoryId(Number(category?.value ?? 0));
    }
  }, [category]);

  useEffect(() => {
    if (response?.status === 200) {
      toast.success("카테고리가 삭제되었습니다.");
      closeEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      if (error?.data === "using") {
        setUsingCategory(true);
      } else {
        toast.error(error?.data ?? "카테고리 삭제에 실패하였습니다.");
      }
    }
  }, [error]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="카테고리 삭제"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setAskDeleteModal(true)}
        isMediumModal={true}
        isDeleteModal={true}
        confirmDisabled={reason === ""}
      >
        <>
          <Flex style={{ marginBottom: 24 }}>
            <ModalLabel>카테고리 선택</ModalLabel>

            <FaqCategoryDropdown
              dropdownValue={category}
              setDropDownValue={setCategory}
              boxWidth={330}
            />
          </Flex>

          <ModalLabel>삭제 사유</ModalLabel>

          <Textarea
            placeholder="삭제 사유 입력(100글자 이내)"
            onChange={(e) => setReason(e.target.value)}
            value={reason}
            disabled={category?.value === ""}
          />
        </>
      </DefaultModalLayout>

      {usingCategory && (
        <AlertModal
          title={`사용 중인 카테고리는 삭제할 수 없습니다.
          해당 카테고리를 사용하는 포스트를 수정 후 삭제해 주세요.`}
          customCancelBtn={<></>}
          confirmEvent={() => {
            setUsingCategory(false);
          }}
        />
      )}

      {askDeleteModal && (
        <AlertModal
          title={`${category?.label} 카테고리를 삭제합니다.
      계속하시겠습니까?`}
          confirmEvent={() => {
            setDeleteAction(true);
            setAskDeleteModal(false);
          }}
          cancelEvent={() => setAskDeleteModal(false)}
        />
      )}

      {loading && <Loader />}
    </>
  );
}
